import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import { Checkbox, Grid, Radio, Slider, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TabsBtn from "./TabsBtn";

const theme = createTheme({
  palette: {
    secondary: {
      main: "#2B817B",
    },
  },
});

export const SideSlider = () => {
  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const [selectedValue, setSelectedValue] = React.useState("");
  const [value1, setValue1] = React.useState("");
  const [getDietry, setgetDietry] = React.useState("");
  const [subscription, setSubscription] = React.useState(false);

  const handleChange1 = (event) => {
    setValue1(event.target.value);
  };
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handleChangeDietry = (event) => {
    setgetDietry(event.target.value);
  };
  const handleChangesubs = (event) => {
    setSubscription(event.target.checked);
  };
  const setDefault = (event) => {
    setValue1(event.target.value);
    setSelectedValue(event.target.value);
    setgetDietry(event.target.value);
    setSubscription(event.target.checked);
  };

  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  const controlProps1 = (item) => ({
    checked: value1 === item,
    onChange: handleChange1,
    value: item,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item },
  });
  const controlPropsDietry = (item) => ({
    checked: getDietry === item,
    onChange: handleChangeDietry,
    value: item,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item },
  });
  const resetbtn = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    // padding: '14px 48px',
    width: "160px",
    height: "34px",
    background: "#FFFFFF",
    border: "1px solid #559A95",
    borderRadius: "6px",
    margin: " 0px auto",
  };
  const inlineStyleRated = {
    padding: "7px 15px",
    fontFamily: "Outfit",
    width: "145px",
    height: "40px",
    left: "0px",
    top: "52px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E1E1E6",
    borderRadius: "42px 0px 0px 42px",
  };
  const inlineStyleRated2 = {
    padding: "7px 15px",
    fontFamily: "Outfit",
    width: "145px",
    height: "40px",
    left: "0px",
    top: "52px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E1E1E6",
    borderRadius: "0px 42px 42px 0px",
  };
  const minDistance = 30;
  const [value, setValue] = React.useState([1, 40]);

  const handleChangeSlider = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (activeThumb === 0) {
      setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
    } else {
      setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
    }
    console.log(value);
  };
  function valuetext(value) {
    return `${value}`;
  }
  const list = (anchor) => (
    // --------------
    <Box
      sx={{
        width: anchor === "left" || anchor === "bottom" ? "auto" : 250,
        padding: "10px",
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <Grid>
          <form>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontFamily: "Outfit",
                  fontStyle: "normal",
                  fontSize: "20px",
                  color: "#1A1824",
                  fontWeight: "600",
                }}
              >
                sort by
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                style={{ marginBottom: "-10px" }}
              >
                <Typography
                  variant=""
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Best Match
                </Typography>
                <ThemeProvider theme={theme}>
                  <Radio
                    size="small"
                    defaultChecked={true}
                    {...controlProps("bestmatch")}
                    name="bestmatch"
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant=""
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Popular
                </Typography>
                <ThemeProvider theme={theme}>
                  <Radio
                    size="small"
                    {...controlProps("popular")}
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
            </Box>
            <Box sx={{ marginTop: 3 }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontFamily: "Outfit",
                  fontStyle: "normal",
                  fontSize: "20px",
                  color: "#1A1824",
                  fontWeight: "600",
                }}
              >
                Order Type
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                style={{ marginBottom: "-10px" }}
              >
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Show only business
                  <br /> subscription
                </Typography>
                <ThemeProvider theme={theme}>
                  <Checkbox
                    size="small"
                    sx={{ borderRadius: 2, backgroundColor: "white" }}
                    checked={subscription}
                    onChange={handleChangesubs}
                    inputProps={{ "aria-label": "controlled" }}
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
            </Box>

            <Box sx={{ marginTop: 3 }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontFamily: "Outfit",
                  fontStyle: "normal",
                  fontWeight: "600",
                  fontSize: "20px",
                  color: "#1A1824",
                }}
              >
                Resto Settings
              </Typography>
              <Box
                sx={{ display: "flex", alignItems: "center" }}
                style={{ marginBottom: "-10px" }}
              >
                <Box style={inlineStyleRated}>
                  <i
                    style={{ color: "#FAA641" }}
                    className="fa-sharp fa-solid fa-star"
                  ></i>
                  Rated 4.0 +
                </Box>
                <Box style={inlineStyleRated2}>
                  <i
                    style={{ color: "#FAA641" }}
                    className="fa-sharp fa-solid fa-star"
                  ></i>
                  Rated 4.0 +
                </Box>
              </Box>
            </Box>

            <Box sx={{ marginTop: 3 }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontFamily: "Outfit",
                  fontStyle: "normal",
                  fontWeight: "600",
                  fontSize: "20px",
                  color: "#1A1824",
                }}
              >
                Price Range
              </Typography>
              <Box sx={{ width: "96%", margin: "auto" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "98%",
                    marginBottom: -1,
                  }}
                >
                  <Typography
                    variant=""
                    gutterBottom
                    sx={{
                      fontFamily: "Outfit",
                      fontStyle: "normal",
                      fontSize: "16px",
                      color: "#1A1824",
                    }}
                  >
                    <ThemeProvider theme={theme}>
                      <Radio
                        size="small"
                        {...controlProps1("monthly")}
                        name="monthly"
                        color="secondary"
                      />
                    </ThemeProvider>
                    Monthly
                  </Typography>
                  <Typography
                    variant=""
                    gutterBottom
                    sx={{
                      fontFamily: "Outfit",
                      fontStyle: "normal",
                      fontSize: "16px",
                      color: "#1A1824",
                    }}
                  >
                    <ThemeProvider theme={theme}>
                      <Radio
                        size="small"
                        {...controlProps1("weekly")}
                        color="secondary"
                      />
                    </ThemeProvider>
                    Weekly
                  </Typography>
                </Box>
                <ThemeProvider theme={theme}>
                  <Slider
                    getAriaLabel={() => "price range"}
                    value={value}
                    valueLabelDisplay="on"
                    onChange={handleChangeSlider}
                    getAriaValueText={valuetext}
                    disableSwap
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
            </Box>
            <Box sx={{ marginTop: 3 }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontFamily: "Outfit",
                  fontStyle: "normal",
                  fontSize: "20px",
                  color: "#1A1824",
                  fontWeight: "600",
                }}
              >
                Dietary
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                style={{ marginBottom: "-10px" }}
              >
                <Typography
                  variant=""
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Vegetarian
                </Typography>
                <ThemeProvider theme={theme}>
                  <Radio
                    size="small"
                    defaultChecked
                    {...controlPropsDietry("vegetraian")}
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant=""
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Vegan
                </Typography>
                <ThemeProvider theme={theme}>
                  <Radio
                    size="small"
                    {...controlPropsDietry("vegan")}
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant=""
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Halal
                </Typography>
                <ThemeProvider theme={theme}>
                  <Radio
                    size="small"
                    {...controlPropsDietry("halal")}
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant=""
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Low-crab
                </Typography>
                <ThemeProvider theme={theme}>
                  <Radio
                    size="small"
                    {...controlPropsDietry("low-crab")}
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant=""
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Gluten Friendly
                </Typography>
                <ThemeProvider theme={theme}>
                  <Radio
                    size="small"
                    {...controlPropsDietry("gluten")}
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant=""
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Lactose-Free
                </Typography>
                <ThemeProvider theme={theme}>
                  <Radio
                    size="small"
                    {...controlPropsDietry("lactodose")}
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant=""
                  gutterBottom
                  sx={{
                    fontFamily: "Outfit",
                    fontStyle: "normal",
                    fontSize: "16px",
                    color: "#1A1824",
                  }}
                >
                  Dairy-Free
                </Typography>
                <ThemeProvider theme={theme}>
                  <Radio
                    size="small"
                    {...controlPropsDietry("dairy")}
                    color="secondary"
                  />
                </ThemeProvider>
              </Box>
            </Box>
            <button style={resetbtn} onClick={setDefault} type="reset">
              Reset
            </button>
          </form>
        </Grid>
      </List>
    </Box>
  );

  return (
    <div>
      {["Search Filter"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button
            variant="contained"
            size="small"
            sx={{ ml: "10px" }}
            onClick={toggleDrawer(anchor, true)}
          >
            {anchor}
          </Button>
          <Drawer
            sx={{ width: 150 }}
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
};
